/* eslint-disable jsx-a11y/alt-text */
import * as React from 'react';
import styles from './popup.module.css';

import shell from '../../img/shell.gif';
export interface PopupInfo {
  iconSrc?: string;
  title?: string;
  msg?: string | React.JSX.Element ;
  ok?: string;
  cancel?: string;
  okCallback?: Function;
  cancelCallback?: Function;  
  okAttr?: Object;
  cancelAttr?: Object;
  nonCancellable?: boolean;
}

interface State {
  info: PopupInfo;
  visible: boolean;
}

export default class Popup extends React.Component<{}, State> {
  private static instance: Popup;
  private static queue: PopupInfo[] = [];

  public static create(newInfo: PopupInfo) {
    Popup.show({ok: 'ok', nonCancellable: false, iconSrc: shell, ...newInfo});
  }

  public static createError(newInfo: PopupInfo) {
    Popup.show({ok: 'ok', nonCancellable: false, iconSrc: shell, title: 'error', ...newInfo});
  }

  // A popup that arrives while another is visible queues instead of replacing it
  private static show(info: PopupInfo) {
    if (!Popup.instance.state.visible) {
      Popup.instance.setState({info, visible: true});
      return;
    }
    if (Popup.isDuplicate(info)) return;
    Popup.queue.push(info);
  }

  private static isDuplicate(info: PopupInfo) {
    const same = (other: PopupInfo) => other.title === info.title && other.msg === info.msg;
    return same(Popup.instance.state.info) || Popup.queue.some(same);
  }

  public static close() {
    Popup.instance.close();
  }

  constructor(props: {}) {
    super(props);
    this.state = { 
      visible: false,
      info: {
        ok: 'ok',
        nonCancellable: false,
        iconSrc: shell
      }
    };
    this.close = this.close.bind(this);
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    Popup.instance = this;
  }

  private async ok() {
    if (this.state.info.okCallback) {
      const close = await this.state.info.okCallback();
      if (close === false) return;
    }
    if (this.state.info.nonCancellable) return;
    this.close();
    
  }

  private cancel() {
    if (this.state.info.cancelCallback) this.state.info.cancelCallback();
    this.close();
  }

  private close() {
    if (this.state.info.nonCancellable) return;
    const next = Popup.queue.shift();
    if (next) this.setState({info: next, visible: true});
    else this.setState({visible: false});
  }

  render() {
    if (!this.state.visible) return <div/>;
    const {info} = this.state;
    return (
      <div className={styles.wrapper} onClick={this.cancel}>
        <div className={styles.popup} onClick={(event) => event.stopPropagation()}>
          {info.iconSrc && 
            <div className={styles.icon}>
              <img src={info.iconSrc}/>
            </div>
          }
          <div className={styles.innerPopup}>
            <div className={styles.title}>{info.title}</div>
            {typeof info.msg === 'string' ? 
              <div className={styles.msg}>{info.msg}</div> : 
              <>{info.msg}</>
            }
            <div className={styles.buttons}>
              {!!info.cancel && 
                <button className={styles.buttonCancel} onClick={this.cancel}  {...info.cancelAttr}>{info.cancel}</button>}
               {!!info.ok &&
                <button className={styles.buttonOk} onClick={this.ok} {...info.okAttr}>{info.ok}</button>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}